import { render, staticRenderFns } from "./UpdateSpots.vue?vue&type=template&id=ef79ea18&scoped=true&"
import script from "./UpdateSpots.vue?vue&type=script&lang=js&"
export * from "./UpdateSpots.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSpots.vue?vue&type=style&index=0&id=ef79ea18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef79ea18",
  null
  
)

export default component.exports